import React from "react";

export const InputTypes = {
  text: "t",
  userRole: "ur",
};

export default ({ label, data, classes, style , labelStyle, rowStyle, showCustomTitle = false, customTitle = null, customLabelTitle = null, isPopOut = false}) => {
  return (
    <div className={classes.muDetailWrap}  style={rowStyle}>
      <div title={customLabelTitle ? customLabelTitle : label} className={isPopOut? classes.muLabelsTrackPopOut : classes.muLabels} style={labelStyle}>{label}</div><div className={classes.muSeperator}>:</div> 
      <div title={showCustomTitle && (customTitle || customTitle=="")? customTitle : data} className={classes.muDetails} style={style}>
         {data}
      </div>
    </div>
  );
};
